const SALARY_ACTIONS = {
  //get allowance
  GET_PAYROLL_ALLOWANCE: "GET_PAYROLL_ALLOWANCE",
  GET_PAYROLL_ALLOWANCE_SUCCESS: "GET_PAYROLL_ALLOWANCE_SUCCESS",
  GET_PAYROLL_ALLOWANCE_FAIL: "GET_PAYROLL_ALLOWANCE_FAIL",
  //get insurance
  GET_PAYROLL_INSURANCE: "GET_PAYROLL_INSURANCE",
  GET_PAYROLL_INSURANCE_SUCCESS: "GET_PAYROLL_INSURANCE_SUCCESS",
  GET_PAYROLL_INSURANCE_FAIL: "GET_PAYROLL_INSURANCE_FAIL",
  //get PIT
  GET_PAYROLL_PIT: "GET_PAYROLL_PIT",
  GET_PAYROLL_PIT_SUCCESS: "GET_PAYROLL_PIT_SUCCESS",
  GET_PAYROLL_PIT_FAIL: "GET_PAYROLL_PIT_FAIL",
  //get payroll users
  GET_PAYROLL_USERS: "GET_PAYROLL_USERS",
  GET_PAYROLL_USERS_SUCCESS: "GET_PAYROLL_USERS_SUCCESS",
  GET_PAYROLL_USERS_FAIL: "GET_PAYROLL_USERS_FAIL",
  //get payroll user setting
  GET_PAYROLL_USER_SETTING: "GET_PAYROLL_USER_SETTING",
  GET_PAYROLL_USER_SETTING_SUCCESS: "GET_PAYROLL_USER_SETTING_SUCCESS",
  GET_PAYROLL_USER_SETTING_FAIL: "GET_PAYROLL_USER_SETTING_FAIL",
  //get PIT
  GET_PAYROLL_CONTRATCS: "GET_PAYROLL_CONTRATCS",
  GET_PAYROLL_CONTRATCS_SUCCESS: "GET_PAYROLL_CONTRATCS_SUCCESS",
  GET_PAYROLL_CONTRATCS_FAIL: "GET_PAYROLL_CONTRATCS_FAIL",
  //get PIT
  GET_USER_PAYROLL: "GET_USER_PAYROLL",
  GET_USER_PAYROLL_SUCCESS: "GET_USER_PAYROLL_SUCCESS",
  GET_USER_PAYROLL_FAIL: "GET_USER_PAYROLL_FAIL",
  //get payroll users
  EXPORT_PAYROLL_USERS: "EXPORT_PAYROLL_USERS",
  EXPORT_PAYROLL_USERS_SUCCESS: "EXPORT_PAYROLL_USERS_SUCCESS",
  EXPORT_PAYROLL_USERS_FAIL: "EXPORT_PAYROLL_USERS_FAIL",
  //get PIT
  GET_PAYROLL_CONVERSION: "GET_PAYROLL_CONVERSION",
  GET_PAYROLL_CONVERSION_SUCCESS: "GET_PAYROLL_CONVERSION_SUCCESS",
  GET_PAYROLL_CONVERSION_FAIL: "GET_PAYROLL_CONVERSION_FAIL",
  //get allowance user
  GET_PAYROLL_ALLOWANCE_USER: "GET_PAYROLL_ALLOWANCE_USER",
  GET_PAYROLL_ALLOWANCE_USER_SUCCESS: "GET_PAYROLL_ALLOWANCE_USER_SUCCESS",
  GET_PAYROLL_ALLOWANCE_USER_FAIL: "GET_PAYROLL_ALLOWANCE_USER_FAIL",
  //get generate user payroll
  GENERATE_USER_PAYROLL: "GENERATE_USER_PAYROLL",
  GENERATE_USER_PAYROLL_SUCCESS: "GENERATE_USER_PAYROLL_SUCCESS",
  GENERATE_USER_PAYROLL_FAIL: "GENERATE_USER_PAYROLL_FAIL",
  //get allowance user
  GET_PAYROLL_COMMISION_USER: "GET_PAYROLL_COMMISION_USER",
  GET_PAYROLL_COMMISION_USER_SUCCESS: "GET_PAYROLL_COMMISION_USER_SUCCESS",
  GET_PAYROLL_COMMISION_USER_FAIL: "GET_PAYROLL_COMMISION_USER_FAIL",
  //get overtime user
  GET_PAYROLL_OVERTIME_USER: "GET_PAYROLL_OVERTIME_USER",
  GET_PAYROLL_OVERTIME_USER_SUCCESS: "GET_PAYROLL_OVERTIME_USER_SUCCESS",
  GET_PAYROLL_OVERTIME_USER_FAIL: "GET_PAYROLL_OVERTIME_USER_FAIL",
  //get commission setting
  GET_PAYROLL_COMMISSION_SETTING: "GET_PAYROLL_COMMISSION_SETTING",
  GET_PAYROLL_COMMISSION_SETTING_SUCCESS:
    "GET_PAYROLL_COMMISSION_SETTING_SUCCESS",
  GET_PAYROLL_COMMISSION_SETTING_FAIL: "GET_PAYROLL_COMMISSION_SETTING_FAIL",
};
export default SALARY_ACTIONS;
